// lib/firebase.ts — Firebase initialization for sorted-2026

import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getPerformance } from 'firebase/performance';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: 'sorted-2026',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);

// Explicitly set LOCAL persistence so Firebase caches the auth token in
// IndexedDB and the session survives browser restarts + offline app launches.
// Fire-and-forget: if this fails (e.g. private-browsing restrictions) the
// default persistence still applies and the app continues to work.
setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.warn('[Firebase] Could not set LOCAL persistence:', e);
});

export const googleProvider = new GoogleAuthProvider();

googleProvider.addScope('email');
googleProvider.addScope('profile');
googleProvider.setCustomParameters({ prompt: 'select_account' });

/** Separate provider used solely for Google Drive OAuth (incremental auth). */
export const driveProvider = new GoogleAuthProvider();
driveProvider.addScope('email');
driveProvider.addScope('profile');
driveProvider.addScope('https://www.googleapis.com/auth/drive.file');
// Do not force prompt: 'consent' to allow silent token renewal behind the scenes.
driveProvider.setCustomParameters({ access_type: 'online' });

export const perf = typeof window !== 'undefined' ? getPerformance(app) : null;
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;
